import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../store/database';
import { TIER_ORDER, TIER_LABELS } from '../../config/house.config';
import type { SupportedLang } from '../../config/house.config';

export default function ReleasesPage() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const releases = useStore(s => s.releases.filter(r => !r.deleted_at));
  const member = useStore(s => s.getMember());
  const lang = i18n.language as SupportedLang;
  const tierIdx = member ? TIER_ORDER.indexOf(member.access_tier) : -1;

  const visible = releases.filter(r => r.preview_tiers.some(pt => TIER_ORDER.indexOf(pt) <= tierIdx));

  const statusLabel = (s: string) => {
    if (s === 'upcoming') return t('releases.upcoming');
    if (s === 'live_private' || s === 'live_public') return t('releases.live');
    return t('releases.closed');
  };

  return (
    <div className="space-y-6">
      <h1 className="font-serif text-2xl tracking-widest">{t('releases.title')}</h1>
      {visible.length === 0 && <p className="text-sm text-charcoal/50 font-sans">{t('releases.noReleases')}</p>}
      <div className="space-y-4">
        {visible.map(r => {
          const tr = r.translations[lang] || r.translations.en;
          const hasAccess = r.eligible_tiers.some(et => TIER_ORDER.indexOf(et) <= tierIdx);
          return (
            <button key={r.id} onClick={() => navigate(`/releases/${r.slug}`)} className="w-full text-left border border-charcoal/5 p-6 hover:border-charcoal/15 transition-colors group">
              <div className="flex items-start justify-between">
                <div>
                  <p className="text-[10px] tracking-widest uppercase text-charcoal/20 font-sans mb-1">{r.house_category_slug} · {statusLabel(r.status)}</p>
                  <h2 className="font-serif text-xl group-hover:text-charcoal/70 transition-colors">{tr.title}</h2>
                  <p className="text-sm text-charcoal/50 font-sans mt-2 line-clamp-2">{tr.content}</p>
                </div>
                {!hasAccess && <span className="text-[10px] text-gold font-sans whitespace-nowrap ml-4">🔒</span>}
              </div>
              {r.window_start && r.window_end && (
                <p className="text-[10px] text-charcoal/30 font-sans mt-3">{t('releases.accessWindow')}: {new Date(r.window_start).toLocaleDateString()} – {new Date(r.window_end).toLocaleDateString()}</p>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
